import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row rounded-3xl overflow-hidden min-h-[440px]">
          <div className="w-full lg:w-1/2 relative bg-accent-50 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20shopping%20bags%20with%20fashion%20items%20and%20sneakers%20on%20soft%20warm%20cream%20background%2C%20minimalist%20lifestyle%20flatlay%20with%20gentle%20natural%20lighting%2C%20clean%20aesthetic%20editorial%20photography%2C%20sophisticated%20neutral%20tones%20with%20organic%20texture%2C%20plenty%20of%20negative%20space&width=800&height=600&seq=cta-hoobuy-2026&orientation=landscape"
              alt="Compre Agora - HoobuySpreadsheet"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-accent-500/10"></div>
            <div className="relative z-10 p-8 md:p-12 flex flex-col justify-between h-full min-h-[340px]">
              <span className="text-xs font-medium text-foreground-700 uppercase tracking-wider">
                Hoobuy Sheet
              </span>
              <div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
                  Compre Agora
                </h2>
                <p className="text-xl md:text-2xl font-heading font-extralight text-foreground-600 mt-1">
                  Melhores Preços
                </p>
                <p className="text-lg md:text-xl font-heading font-light text-foreground-700 mt-1">
                  Hoobuy Sheet
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center p-8 md:p-12 lg:p-16 text-center border border-background-200/60 lg:border-l-0">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              Buy It Now
            </h3>
            <p className="text-xl md:text-2xl font-heading font-extralight text-foreground-400 mb-6">
              Agora
            </p>

            <p className="text-sm md:text-base text-foreground-500 font-light leading-relaxed max-w-[380px] mb-8">
              Pronto para descobrir os melhores produtos a preços incríveis? Aceda agora ao HoobuySpreadsheet completo e comece a poupar nas suas compras da China.
            </p>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}